import { Download, Smartphone } from "lucide-react";
import { siteConfig } from "../lib/siteConfig";

export default function AppDownloadCard({ dark = false, className = "" }) {
  return (
    <section
      data-testid="android-download-card"
      className={`rounded-2xl border p-5 shadow-sm sm:p-6 ${
        dark ? "border-[#2F6FA5]/25 bg-[#081421] text-white" : "border-[#2F6FA5]/20 bg-white text-slate-950"
      } ${className}`}
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-center gap-4">
          <div className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-gradient-to-br from-[#2F6FA5] to-emerald-400">
            <Smartphone className="h-5 w-5 text-white" />
          </div>
          <div className="min-w-0">
            <h3 className="text-lg font-bold leading-tight">{siteConfig.name} app</h3>
            <p className={`mt-0.5 text-sm ${dark ? "text-slate-300" : "text-slate-600"}`}>
              Download the Android app for faster access from your phone.
            </p>
          </div>
        </div>
        <a
          href={siteConfig.androidAppDownloadUrl}
          download="FEA-Slots.apk"
          data-testid="android-download-card-button"
          className="inline-flex w-full shrink-0 items-center justify-center gap-2 rounded-full bg-[#2F6FA5] px-5 py-3 font-bold text-white transition-colors hover:bg-[#4E91C8] sm:w-auto"
        >
          <Download className="h-4 w-4" />
          Download App
        </a>
      </div>
    </section>
  );
}
